if (typeof Drupal !== "undefined") {
    Drupal.behaviors.custom_drupal_message = {
        attach: function(context, settings) {
            init();
        }
    };
} else {
    init();
}

function init() {

    // ЗАКРЫВАЕМ СООБЩЕНИЯ ДРУПАЛА
    document.querySelectorAll(".messages__close").forEach(message => {
        message.addEventListener("click", (e) => {
            e.currentTarget.parentElement.remove();
        });
    });
    // КОНЕЦ

}

// всплывающее уведомление (успешное сообщение)
var timer = setInterval(function() {
    let messageStatusOk = document.querySelector(".messages--status");
    if (messageStatusOk) {
        clearInterval(timer);
        setTimeout(()=>{
            messageStatusOk.style.opacity = "1";
            messageStatusOk.style.visibility = "visible";

            let messageProgressBar = document.createElement("div");
            messageProgressBar.style.width= "0";
            messageProgressBar.classList.add("message__progressbar");
            messageStatusOk.querySelector(".messages__close").before(messageProgressBar);

            var progress = 1, timer, percent;
            var bar = messageStatusOk.querySelector(".message__progressbar");
            var loop = function loop (progress) {
                if (progress === 101) {
                    clearTimeout(timer);
                    // messageStatusOk.style.opacity = "0";
                    // messageStatusOk.style.visibility = "hidden";
                    if (messageStatusOk.parentElement.querySelectorAll(".messages").length === 1) {
                        messageStatusOk.parentElement.remove();
                    }
                    messageStatusOk.remove();
                } else {
                    percent = progress * 1;
                    bar.style.width = percent + '%';
                    timer = setTimeout(loop, 15, ++progress);
                }
            };
            loop(progress);

        }, 1000);
    }
}, 300);
// END

// ready(() => {});